export default __webpack_public_path__ + "assets/20eba515371d3ca9e65372f90657d5aa.png";